module.exports = __webpack_public_path__ + "static/media/ottawa-32.4e218f9a.jpg";